class deletePdfTicket {
    constructor($state, $http, alert) {
        this.key = 'delete-pdf-ticket';
        this.title = 'Permanently Delete';
        this.level = 'archived-highlight';
        this.icon = 'trash-alt';
        this.order = 15;
        this.state = $state;
        this.http = $http;
        this.alert = alert;
    }

    // @todo new alert - don't, there is no option to permanently delete pdf ticket
    action(model, vm) {
        this.alert.confirm({
            title: 'Confirm Template Deletion',
            message: `Are you sure you want to permanently delete the ticket template: ${vm.model.name}`,
            confirmBtn: 'Delete'
        })
            .then(() => {
                this.http.delete(`tickets/templates/${vm.model.id}`)
                    .then(() => {
                        this.state.go('app.tickets.templates.index');
                    }, err => this.alert.handle(err));
            }, err => this.alert.handle(err));
    }

}

angular
    .module('festzelt-os.modules.tickets')
    .factory('deleteTicketTemplate', [
        '$state',
        '$http',
        'Alert',
        ($state, $http, Alert) => new deletePdfTicket($state, $http, Alert)
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/tickets/templates/workflows/details/delete-ticket-template.js